import Route from '@ember/routing/route';

export default class SifLogsRoute extends Route {}
